import React from 'react';
import { TrendingDownIcon } from 'lucide-react';
import { PageHero } from '../components/ui/PageHero';
import { Reveal } from '../components/ui/Reveal';
import { ArrowButton } from '../components/ui/ArrowButton';
import { CtaBanner } from '../components/CtaBanner';
import { services } from '../data/services';
import { images } from '../data/images';
export function Services() {
  return <>
      <PageHero label="Services" title="Six expertises pour des achats et une supply chain qui performent." description="Missions ponctuelles, transformations de fond ou direction par intérim : chaque intervention est taillée pour vos enjeux, votre taille et votre calendrier." image={images.warehouse} data-id="element-696" data-mp="153ncq1pbi4t" />

      <section className="bg-paper py-16 lg:py-24" data-id="element-697" data-mp="65redbpxjyz1">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8" data-id="element-698" data-mp="2cumekoczsnkm">
          <nav aria-label="Sommaire des services" className="flex flex-wrap gap-2" data-id="element-699" data-mp="2cx8upcdy8beg">
            {services.map(s => <a key={s.slug} href={`#${s.slug}`} className="rounded-lg bg-white px-4 py-2 text-sm text-ink ring-1 ring-inset ring-ink/10 transition-colors duration-150 hover:bg-ink hover:text-white" data-id="element-700" data-mp="16p2tm6p7fjyu">
                {s.title}
              </a>)}
          </nav>

          <div className="mt-16 divide-y divide-ink/10" data-id="element-701" data-mp="1kh0whzsbojmk">
            {services.map((s, i) => <article key={s.slug} id={s.slug} className="grid scroll-mt-28 gap-10 py-16 lg:grid-cols-12 lg:gap-16" data-id="element-702" data-mp="1peiz78fqy2m4" data-mpi={i}>
                <Reveal className={`lg:col-span-5 ${i % 2 === 1 ? 'lg:order-2' : ''}`} data-id="element-703" data-mp="1uckjtxstm9zp">
                  <div className="aspect-[4/3] overflow-hidden rounded-[28px]" data-id="element-704" data-mp="1ze02jj7j04ex">
                    <img src={s.image} alt="" className="h-full w-full object-cover" data-id="element-705" data-mp="23e231p1iyrsm" />
                  </div>
                </Reveal>
                <div className={`lg:col-span-7 ${i % 2 === 1 ? 'lg:order-1' : ''}`} data-id="element-706" data-mp="51k1qxxi1ihg">
                  <Reveal data-id="element-707" data-mp="91ccnhad80pz">
                    <h2 className="text-[clamp(1.8rem,3.2vw,2.6rem)] font-medium leading-tight tracking-[-0.02em]" data-id="element-708" data-mp="1cbyj9sqkcljf">{s.title}</h2>
                    <p className="mt-3 text-lg text-ink/80" data-id="element-709" data-mp="17donbfx0lgwr">{s.short}</p>
                    <p className="mt-5 max-w-2xl leading-relaxed text-muted" data-id="element-710" data-mp="1lcodis06e3v1">{s.description}</p>
                  </Reveal>
                  <Reveal delay={0.1} data-id="element-711" data-mp="1hajk9udn398x">
                    <h3 className="mt-8 text-sm font-medium text-muted" data-id="element-712" data-mp="1h9hzgy6tn8e0">Ce que je prends en charge</h3>
                    <ul className="mt-3 grid gap-x-8 sm:grid-cols-2" data-id="element-713" data-mp="1v8zqzlbi4zr2">
                      {s.points.map(p => <li key={p} className="border-b border-ink/10 py-3" data-id="element-714" data-mp="1q9wvoslbq7wa">
                          {p}
                        </li>)}
                    </ul>
                    <div className="mt-8 flex flex-wrap items-center gap-6" data-id="element-715" data-mp="202cbpkd28mej">
                      <p className="flex items-center gap-2 font-medium text-brass-dark" data-id="element-716" data-mp="2e23oxivr5yrh">
                        <TrendingDownIcon className="h-5 w-5" aria-hidden="true" data-id="element-717" data-mp="293a7jfdchnm1" />
                        {s.outcome}
                      </p>
                      <ArrowButton to="/contact" data-id="element-718" data-mp="2sm7sfcce0q81">En parler</ArrowButton>
                    </div>
                  </Reveal>
                </div>
              </article>)}
          </div>
        </div>
      </section>

      <CtaBanner data-id="element-719" data-mp="2noo57mxpp33y" />
    </>;
}